import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/vuepage/guide/operationGuide'], resolve),
      meta: {
        title:'操作指南',
        tarIndex:0
      }
    },
    {
      path: '/userMessage',
      component: resolve => require(['@/vuepage/user/newUserMessage'], resolve),
      meta: {
        title:'账户信息',
      }
    },
    {
      path: '/operationGuide',
      component: resolve => require(['@/vuepage/guide/operationGuide'], resolve),
      meta: {
        title:'操作指南',
      }
    },
    {
      path: '/register',
      component: resolve => require(['@/vuepage/register/index'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/stepOne',
      component: resolve => require(['@/vuepage/register/stepOne'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/stepTwo',
      component: resolve => require(['@/vuepage/register/stepTwo'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/stepThree',
      component: resolve => require(['@/vuepage/register/stepThree'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/successTip',
      component: resolve => require(['@/vuepage/register/successTip'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/resetBank',
      component: resolve => require(['@/vuepage/reset/resetBank'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/accountList',
      component: resolve => require(['@/vuepage/account/accountList'], resolve),
      meta: {
        title:'丰昂h5',
      }
    },
    {
      path: '/signFdd',
      component: resolve => require(['@/vuepage/signFdd/signFdd'], resolve),
      meta: {
        title:'法大大签约',
      }
    },
    {
      path: '/loginFdd',
      component: resolve => require(['@/vuepage/signFdd/loginFdd'], resolve),
      meta: {
        title:'签约入口',
      }
    },

    //查询是否签约
    {
      path: '/checkSign',
      component: resolve => require(['@/vuepage/checkSign/checkSign'], resolve),
      meta: {
        title:'签约入口',
      }
    },
    // {
    //   path: '/print',
    //   component: print,
    //   meta: {
    //     title:'小票打印',
    //   }
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js